import {useState} from "react";
import {uniqBy} from 'lodash'
import {Typography, Stack, Divider, Grid} from "@mui/material";
import OrderCartArrows from "./OrderCartArrows";
import OrderCartOptions from "./OrderCartOptions";
import OrderItem from "./OrderItem";
import {useDispatch} from "react-redux";
import {getItemsById} from "../../../redux/slices/vendorOrders.thunks";
import {collectIds} from "../../../utils/items";

export default function OrderCart({name = 'Defaut', onMoveUp, onMoveDown}) {
    const dispatch = useDispatch()
    const [items, setItems] = useState([]);

    const handleAddItems = collection => {
        setItems(uniqBy([...items, ...collection], 'id'))
        dispatch(getItemsById(collectIds(collection)))
    }

    return (
        <Grid container>

            {/*--Arrow--*/}
            <Grid item xs={0.5}>
                <OrderCartArrows onMoveUp={onMoveUp} onMoveDown={onMoveDown}/>
            </Grid>

            {/*--Header--*/}
            <Grid item xs={11}>

                <Stack direction={'column'} spacing={2}>

                    <Stack direction={'row'} spacing={2} justifyContent={'space-between'}>

                        <Stack direction={'column'} justifyContent={'center'}>
                            <Typography variant={'subtitle1'}>
                                {name}
                            </Typography>
                        </Stack>


                        <OrderCartOptions onAddItems={handleAddItems}/>

                    </Stack>

                    <Divider/>


                </Stack>

            </Grid>

            {/*--Selected items--*/}
            <Grid item xs={12} sx={{mx: 10}}>
                <Stack direction={'column'} spacing={2}>

                    {
                        items.map(item => (
                            <OrderItem item={item} key={item?.id}/>
                        ))
                    }

                </Stack>
            </Grid>

        </Grid>
    )
}